:host{
  /* Size */
  --day-button-border-radius: var(--jb-calendar-day-button-border-radius, var(--jb-radius-sm));
  --month-button-border-radius: var(--jb-calendar-month-button-border-radius, var(--jb-radius-sm));
  --year-button-border-radius: var(--jb-calendar-year-button-border-radius, var(--jb-radius-sm));
  /* Theme/Color */
  --color: var(--jb-calendar-color,var(--jb-content-primary));
  --arrow-fill-color: var(--jb-calendar-arrow-fill-color, var(--jb-neutral-6));
  --day-text-color-disabled: var(--jb-calendar-day-text-color-disabled, var(--jb-neutral-8));
  --day-text-color-today: var(--jb-calendar-day-text-color-today, var(--jb-green));
  --day-bg-color-selected: var(--jb-calendar-day-bg-color-selected, var(--jb-neutral));
  --day-color-selected: var(--jb-calendar-day-color-selected, var(--jb-content-inverse));
  --day-bg-color-selected-hover: var(--jb-calendar-day-bg-color-selected-hover, var(--jb-neutral-2));
  --day-color-selected-hover: var(--jb-calendar-day-color-selected-hover, var(--jb-content-inverse));
  --day-bg-color-hover: var(--jb-calendar-day-bg-color-hover,var(--jb-surface-secondary));
  --day-color-hover: var(--jb-calendar-day-color-hover, var(--jb-content-primary));
  --day-text-color: var(--jb-calendar-day-text-color, var(--jb-neutral-4));
  --status-point-bg-color-today: var(--jb-calendar-status-point-bg-color-today, var(--jb-green));
  --status-point-border-color: var(--jb-calendar-status-point-border-color, var(--jb-surface-primary));
  --month-bg-color-hover: var(--jb-calendar-month-bg-color-hover, var(--jb-surface-secondary));
  --month-color-hover: var(--jb-calendar-month-color-hover, var(--jb-content-primary));
  --year-bg-color-hover: var(--jb-calendar-year-bg-color-hover, var(--jb-surface-secondary));
  --year-color-hover: var(--jb-calendar-year-color-hover, var(--jb-content-primary));
  --swipe-up-icon-color: var(--jb-calendar-arrow-fill-color, var(--arrow-fill-color));

}
